export const dataset = [
	{ id: 27, vote: "Cg_EBR5PDd3" },
	{ id: 28, vote: "Cg_FBsfF1jR" },
	{ id: 30, vote: "Cg_FIY-l8IA" },
	{ id: 32, vote: "Cg_FNVllyob" },
	{ id: 33, vote: "Cg_FSZ1lkRM" },
	{ id: 34, vote: "Cg_FdifFRjt" },
	{ id: 36, vote: "Cg_FitVl8IC" },
	{ id: 37, vote: "Cg_Fql0l0Zx" },
	{ id: 40, vote: "Cg_FwAUFxpK" },
	{ id: 42, vote: "Cg_F7roFzi7" },
	{ id: 43, vote: "Cg_GAmcFbQr" },
	{ id: 45, vote: "Cg_GJFSFtgU" },
	{ id: 46, vote: "Cg_GOG2lqjm" },
	{ id: 49, vote: "Cg_GY92l8WL" },
	{ id: 51, vote: "Cg_GdSyltMe" },
];
